import { selector } from 'recoil';

import { projectAtom } from '../atoms/projectAtom';

export const projectHasOptionsSelector = selector({
  key: 'projectHasOptionsSelector',
  get: ({ get }) => get(projectAtom)?.projectType.pricingMerchandiseOptions.length !== 0 ?? true,
});
